import { Badge } from "@newsela/angelou";
import PropTypes from "prop-types";

import { rootCss } from "./LiteOrPremiumBadge.style";

const getLocaleDateString = (utcDateString) =>
  new Date(utcDateString).toLocaleDateString();

const propTypes = {
  isLiteUser: PropTypes.bool,
  isLiteContent: PropTypes.bool,
  expireDateUtc: PropTypes.string,
};

export const LiteOrPremiumBadge = ({
  isLiteUser,
  isLiteContent,
  expireDateUtc,
}) => {
  if (!isLiteUser) return null;

  const text = isLiteContent
    ? `READ UNTIL ${getLocaleDateString(expireDateUtc)}`
    : "PREMIUM";

  return (
    <Badge
      __cssFor={{ root: rootCss }}
      color={Badge.color.blue}
      flavor={Badge.flavor.solid}
      text={text}
    />
  );
};

LiteOrPremiumBadge.propTypes = propTypes;

export default LiteOrPremiumBadge;
